import React from "react";
import { Card } from "antd";
import {
    fallbackSubjectView,
    getCoveragePeriod,
} from "../utils/workbenchNewSubjectView";
import { WbSubject } from "../../workbench/types/WbTypes";

type Props = {
    broker: string;
    cedent: string;
    claimant: string;
    mainClass: string;
    subject?: WbSubject | null;
};

const WorkbenchNewSubjectSummary: React.FC<Props> = ({
    broker,
    cedent,
    claimant,
    mainClass,
    subject,
}) => (
    <Card className="workbench-new-subject-card workbench-new-subject-summary">
        <div className="workbench-new-subject-card-title">Case summary</div>
        <div className="workbench-new-subject-ai-summary">
            <span
                aria-hidden="true"
                className="workbench-new-subject-ai-summary-icon"
            />
            <span className="workbench-new-subject-ai-summary-copy">
                2 layers identified across this Excess of Loss program, with
                worldwide coverage excluding US & Canada.
            </span>
        </div>
        <div className="workbench-new-subject-metrics">
            <div className="workbench-new-subject-metric">
                <strong>2</strong>
                <span>Layers identified</span>
            </div>
            <div className="workbench-new-subject-metric">
                <strong>{fallbackSubjectView.totalLimit}</strong>
                <span>Total limit</span>
            </div>
            <div className="workbench-new-subject-metric">
                <strong>{fallbackSubjectView.totalPremium}</strong>
                <span>Total premium</span>
            </div>
        </div>
        <div className="workbench-new-subject-summary-subtitle">
            Key contract facts
        </div>
        <dl className="workbench-new-subject-facts">
            <div>
                <dt>Business type</dt>
                <dd>{fallbackSubjectView.businessType}</dd>
            </div>
            <div>
                <dt>Class of business</dt>
                <dd>{mainClass}</dd>
            </div>
            <div>
                <dt>Coverage period</dt>
                <dd>{getCoveragePeriod(subject)}</dd>
            </div>
            <div>
                <dt>Coverage</dt>
                <dd>{fallbackSubjectView.coverage}</dd>
            </div>
            <div>
                <dt>Partners</dt>
                <dd>{[broker, cedent, claimant].filter(Boolean).join(", ")}</dd>
            </div>
            <div>
                <dt>Currency</dt>
                <dd>{fallbackSubjectView.currency}</dd>
            </div>
        </dl>
        <div className="workbench-new-subject-case-footer">
            <a
                className="workbench-new-programme-link"
                href="/"
                onClick={(event) => event.preventDefault()}
            >
                View in AI
            </a>
            <div className="workbench-new-subject-data-state">
                <span>Source:</span>
                <strong>ERGO 2026 Property Draft Slip.docx</strong>
                <span className="workbench-new-subject-data-separator">.</span>
                <span>
                    AI analysis: <strong>13 May 2026</strong>
                </span>
                <span className="workbench-new-subject-data-separator">.</span>
                <span>
                    SICS: <strong>Not created</strong>
                </span>
            </div>
        </div>
    </Card>
);

export default WorkbenchNewSubjectSummary;
